import '@fiverr/globals';
import dateFormat from 'dateformat/lib/dateformat';

/**
 * Calculate the earliest date the gig can be delivered
 * @param  {Integer} {fastestDeliveryTime} The gig's fastest delivery time (number of days)
 * @return {String} The earliest date the gig can be delivered
 */

export function getItByDate(fastestDeliveryTime) {
    const today = new Date(),
        deliveryDate = new Date(),
        isTomorrow = fastestDeliveryTime === 1;

    deliveryDate.setDate(today.getDate() + fastestDeliveryTime);

    const day = deliveryDate.getDate(),
        month = deliveryDate.getMonth(),
        dayOfWeekIndex = deliveryDate.getDay(),
        dayOfWeek = dateFormat.i18n.dayNames[dayOfWeekIndex + 7],
        prefix = isTomorrow ? i18n.t('delivery_time.tomorrow') : dayOfWeek,
        monthName = dateFormat.i18n.monthNames[month];

    return `${prefix}, ${monthName} ${day}`;
}



// WEBPACK FOOTER //
// ./src/utils/getItByDate/index.js